import { render, staticRenderFns } from "./TasksMadeFilters.vue?vue&type=template&id=3948bfe3&scoped=true"
import script from "./TasksMadeFilters.vue?vue&type=script&lang=js"
export * from "./TasksMadeFilters.vue?vue&type=script&lang=js"
import style0 from "./TasksMadeFilters.vue?vue&type=style&index=0&id=3948bfe3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948bfe3",
  null
  
)

export default component.exports